module.exports = __webpack_public_path__ + "static/media/liquidity-tokens.efce7779.svg";